import axios from 'axios';
// axios默认请求域名
// axios.defaults.baseURL = '//db10.gamersky.com/StrategySetsEditor/'
// axios请求是否携带cookie
axios.defaults.withCredentials = true;

const ajax = {
    post: function (url, data = {})
    {

        let timeoutSeconds = data["_timeoutSeconds"];
        if (timeoutSeconds
            && timeoutSeconds != null)
        {
            delete (data["_timeoutSeconds"]);
        }

        return new Promise((resolve, reject) =>
        {
            axios.post(
                url, data,
                {
                    // timeout: timeoutSeconds * 3000
                })
                .then((response) =>
                {
                    resolve(response.data);
                })
                .catch((error) =>
                {
                    reject(error);
                });
        })
    },

    get: function (url, params = {})
    {

        let timeoutSeconds = params["_timeoutSeconds"];
        if (timeoutSeconds
            && timeoutSeconds != null)
        {
            delete (params["_timeoutSeconds"]);
        }

        return new Promise((resolve, reject) =>
        {
            axios.get(url, {
                params: params,
                // timeout: timeoutSeconds * 3000
            })
                .then((response) =>
                {
                    console.log(response)
                    resolve(response.data);
                })
                .catch((error) =>
                {
                    console.log(error)
                    reject(error);
                });
        })
    },

    jsonp: function (url, data = {})
    {
        if (!url)
            throw new Error('url is necessary')
        const callback = 'CALLBACK' + Math.random().toString().substr(9, 18)
        const JSONP = document.createElement('script')
        JSONP.setAttribute('type', 'text/javascript')

        const headEle = document.getElementsByTagName('head')[0]
        let ret = '';
        if (data)
        {
            if (typeof data === 'string')
                ret = '&' + data;
            else if (typeof data === 'object')
            {
                for (let key in data)
                    ret += '&' + key + '=' + encodeURIComponent(data[key]);
            }
            ret += '&_=' + Date.now();
        }
        JSONP.src = `${url}?callback=${callback}${ret}`;
        return new Promise((resolve, reject) =>
        {
            window[callback] = r =>
            {
                resolve(r)
                headEle.removeChild(JSONP)
                delete window[callback]
            }
            headEle.appendChild(JSONP)
        })
    },

    CrossPost: function (url, data = {})
    {
        return new Promise((resolve, reject) =>
        {
            ajax.post("//instrument.gamersky.com/HTTPHelper/CrossPost", {
                url: url,
                postData: JSON.stringify(data)
            }).then(response =>
            {
                response = JSON.parse(response);
                resolve(response);
            }).catch(error =>
            {
                reject(error);
            });
        })
    },

};


// 请求拦截器
axios.interceptors.request.use(request =>
{
    try
    {
        var currentUserInfo = GSAppJsApi.User.getCurrentUser();
        if (currentUserInfo != null
            && currentUserInfo.id
            && currentUserInfo.id != null
            && currentUserInfo.id != 0)
        {
            var currentUserInfoJsonUrlEncoded
                = encodeURIComponent(JSON.stringify(currentUserInfo));
            // !!!
            request.headers['GS-User-Info'] = currentUserInfoJsonUrlEncoded;
            // !!!
            // !!!
            var requestUrl = request.url;
            var sharpIndexInRequestUrl = requestUrl.indexOf("#");
            var requestUrlCharsBeforeSharp = requestUrl;
            var requestUrlCharsEqualAfterSharp = null;
            if (sharpIndexInRequestUrl > 0)
            {
                requestUrlCharsBeforeSharp = requestUrl.substring(0, sharpIndexInRequestUrl);
                requestUrlCharsEqualAfterSharp = requestUrl.substring(sharpIndexInRequestUrl);
            }
            if (requestUrlCharsBeforeSharp.indexOf("?") >= 0)
            {
                if (!requestUrlCharsBeforeSharp.endsWith("&"))
                {
                    requestUrlCharsBeforeSharp += "&";
                }
            }
            else
            {
                // requestUrlCharsBeforeSharp += "?";
            }
            // !!!
            // requestUrlCharsBeforeSharp += "gsUserId=" + currentUserInfo.id;
            // !!!
            request.url
                = requestUrlCharsEqualAfterSharp != null
                    ? (requestUrlCharsBeforeSharp + requestUrlCharsEqualAfterSharp)
                    : requestUrlCharsBeforeSharp;
            // !!!
        }
    }
    catch (exception)
    {
        console.error("为请求增加游民用户信息失败，程序异常：\r\n" + exception);
    }
    return request;
}, (error) =>
{
    return Promise.reject(error);
});

// // 响应拦截器
// axios.interceptors.response.use(function (response) {
//     // if (response.data.Error != "") {
//     //     localStorage.removeItem('userInfo')
//     //     Vue.$router.replace({name: 'login'})
//     // }
//     return response;
// }, function (error) {
//     return Promise.reject(error);
// });


export default ajax;